import GameRules from "./GameRules"

GameRules.defaultProps = {
  bannerImage: "",
  colors: {
    primary: "#0F1635",
    primaryFont: "#ffffff",
    secondary: "#ffffff",
    secondaryFont: "#0F1635",
  },
  gameMode: "Punkte",
  quizTagline: "Ja -Ja Ding Dong!",
  quizTitle: "Eurovision The Movie",
  rules: [
    "Richtige Antworten geben Punkte, falsche kosten Punkte.",
    "Je schneller du antwortest, desto mehr Punkte gewinnst oder verlierst du.",
    "Wenn du nicht antwortest, bleibt deine Punktzahl unverändert, spiel also strategisch!",
    "Der Spieler mit den meisten Punkten am Ende gewinnt.",
  ],
}

export default GameRules
